import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-137a9243"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "Logo",
  src: "https://monet-prtl-co.imgix.net/Shared/Registration/facebook_color.png",
  alt: "FacebookLogo"
}, null, -1 /* HOISTED */))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "BigOnly" }, "Sign in with "),
  /*#__PURE__*/_createTextVNode("Facebook ")
], -1 /* HOISTED */))
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("button", {
    ref: "root",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.authenticate && _ctx.authenticate(...args))),
    class: _normalizeClass([_ctx.pending ? 'Pending ' + _ctx.template : _ctx.template, "Provider FacebookLogin"]),
    type: "button"
  }, _hoisted_3, 2 /* CLASS */))
}